import { generate } from 'short-uuid';

const UNIQUE_CHAT_WINDOW_KEY = 'CHAT_WINDOW_ID';

const isSessionStorageAvailable = () => {
  try {
    sessionStorage.setItem('test_key', 'storage_test');
    sessionStorage.removeItem('test_key');
    return true;
  } catch (_e) {
    return false;
  }
};

const inMemoryStorageService = () => {
  let inMemoryStorage = {};

  return {
    get: (key: string, callback?: (...args: any[]) => void) => {
      const storageItem = inMemoryStorage[key];
      if (storageItem) {
        return storageItem;
      }
      if (typeof callback === 'function') {
        return callback();
      }
      return storageItem;
    },
    set: (key: string, value: string) => {
      if (value) {
        inMemoryStorage[key] = JSON.stringify(value);
      }
    },
    delete: (key: string) => {
      inMemoryStorage[key] = undefined;
    },
    clear: () => {
      inMemoryStorage = {};
    },
  };
};

const sessionStorageService = () => ({
  get: (key: string, callback?: (...args: any[]) => void) => {
    const storageItem = sessionStorage.getItem(key);
    if (storageItem) {
      return storageItem;
    }
    if (typeof callback === 'function') {
      return callback();
    }
    return storageItem;
  },
  set: (key: string, value: string) => {
    if (value) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  },
  delete: (key: string) => {
    sessionStorage.removeItem(key);
  },
  clear: () => {
    sessionStorage.clear();
  },
});

// In private browser mode ( incognito mode ), localStorage is not available
const storageService = isSessionStorageAvailable()
  ? sessionStorageService()
  : inMemoryStorageService();

export const getUniqueChatWindowId = () => {
  try {
    return storageService?.get(UNIQUE_CHAT_WINDOW_KEY);
  } catch (_error) {
    storageService?.delete(UNIQUE_CHAT_WINDOW_KEY);
    return '';
  }
};

export const setUniqueChatWindowId = () => {
  try {
    return storageService?.set(UNIQUE_CHAT_WINDOW_KEY, generate());
  } catch (_error) {
    return '';
  }
};

// In private browser mode ( incognito mode ), localStorage is not available
export default storageService;
